<script setup>
import { computed } from "vue";

const props = defineProps({
  list: {
    type: Array,
    required: true,
    default: null
  }
});

const checkTarget = function (selectedItem) {
  if (props.list) {
    if (selectedItem.targetFlg) {
      // 既にtrueの場合は他をfalseに
      props.list.forEach(item => {
        item.targetFlg = item === selectedItem;
      });
    } else {
      // falseの場合は全てfalseに（選択解除）
      props.list.forEach(item => {
        item.targetFlg = false;
      });
    }
  }
};

const isDisplayTarget = computed(() => {
  if (props.list) {
    return props.list.length > 1;
  }
  return false;
});
</script>

<template lang="pug">
  div(v-if="list != null && list.length > 0")
    table
      tr
        th 受注希望者
        th 部署
        th 登録日時
        th(v-if="isDisplayTarget") 受注対象
      template(v-for="item in list" )
        tr(:key="item.id")
          td
            span {{item.userName}}
          td
            span {{item.departmentName}}
          td
            span {{item.updatedAtDisplay}}
          td(v-if="isDisplayTarget").checkbox-column
            v-checkbox(v-model="item.targetFlg" @change="checkTarget(item)")
</template>

<style scoped lang="stylus">
table
  border-collapse collapse
  th, td
    padding 0.5em
    border 1px solid #ccc

.checkbox-column2
  .v-input--checkbox
    margin 0 auto
    display table
    vertical-align middle
</style>
